import { Slider, useTheme } from '@mui/material'
import React from 'react'
import { getThemeStylesForRangeSlider } from './utils/getThemeStylesForRangeSlider'

interface LabResultRangeProps {
    min: number
    max: number
    valueQuantity?: number
    unit?: string // We don't use this yet, but we might need it in the future
}

export const LabResultRange = ({
    min,
    max,
    valueQuantity = 0
}: LabResultRangeProps) => {
    const theme = useTheme()

    const marks = React.useMemo(
        () => [
            {
                value: min,
                label: min
            },
            {
                value: valueQuantity || 0,
                label: valueQuantity || 0
            },
            {
                value: max,
                label: max
            }
        ],
        [min, max, valueQuantity]
    )

    const padding = (max - min) * 0.1

    return (
        <Slider
            getAriaLabel={() => 'Lab Result Range'}
            value={[min, max]}
            min={Math.min(min, valueQuantity) - padding}
            max={Math.max(max, valueQuantity) + padding}
            marks={marks}
            disabled
            sx={getThemeStylesForRangeSlider(theme)}
            getAriaValueText={value => `${value}`}
        />
    )
}
